const normalizeBasePath = (value?: string | null) => {
  if (!value) {
    return "/";
  }

  const trimmed = value.trim();
  if (!trimmed || trimmed === "/") {
    return "/";
  }

  const withoutOrigin = trimmed.replace(/^[a-z]+:\/\/[^/]+/i, "");
  const withLeadingSlash = withoutOrigin.startsWith("/")
    ? withoutOrigin
    : `/${withoutOrigin}`;
  const withoutTrailingSlash = withLeadingSlash.replace(/\/+$/, "");

  return withoutTrailingSlash ? `${withoutTrailingSlash}/` : "/";
};

const getBaseHrefPath = () => {
  if (typeof document === "undefined") {
    return undefined;
  }

  const baseHref = document.querySelector("base")?.getAttribute("href");
  if (!baseHref) {
    return undefined;
  }

  return new URL(baseHref, window.location.origin).pathname;
};

const envPublicPath = typeof process !== "undefined" && process?.env ? process.env.CLIENT_PUBLIC_PATH : undefined;

export const appBasePath = normalizeBasePath(envPublicPath || getBaseHrefPath());

export const routerBasename =
  appBasePath === "/" ? undefined : appBasePath.replace(/\/$/, "");

export const buildAppPath = (pathname = "/") => {
  const normalizedPath = pathname.startsWith("/") ? pathname : `/${pathname}`;

  return routerBasename ? `${routerBasename}${normalizedPath}` : normalizedPath;
};
